import { Enum_Environment } from "@/views/Main/MainBean";

export const MapboxLonLatPositionInfoOptions: { [key in Enum_Environment]: { position: "fixed", left: string, bottom: string, zIndex?: string } } = {
    [Enum_Environment.IntelligentWarning]: {
        position: "fixed",
        left: "calc(100% - 220px)",
        bottom: "75px"
    },
    [Enum_Environment.FactsMonitor]: {
        position: "fixed",
        left: "calc(100% - 695px)",
        bottom: "10px",
    },
    [Enum_Environment.ShortImpending]: {
        position: "fixed",
        left: "calc(100% - 495px)",
        bottom: "75px"
    },
    [Enum_Environment.ForecastProduction]: {
        position: "fixed",
        left: "calc(100% - 215px)",
        bottom: "calc(100% - 85px)"
    },
    [Enum_Environment.ModeForecast]: {
        position: "fixed",
        left: "calc(100% - 240px)",
        bottom: "calc(100% - 40px)"
    },
    [Enum_Environment.IntelligentGrid]: {
        position: "fixed",
        left: "calc(100% - 632px)",
        bottom: "calc(100% - 80px)"
    },
    [Enum_Environment.DecisionService]: {
        position: "fixed",
        left: "",
        bottom: "5px"
    },
    [Enum_Environment.Typhoon]: {
        position: "fixed",
        left: "355px",
        bottom: "calc(100% - 80px)"
    },
    [Enum_Environment.Guarantee]: {
        position: "fixed",
        left: "",
        bottom: ""
    },
    [Enum_Environment.Convention]: {
        position: "fixed",
        left: "",
        bottom: ""
    },
    [Enum_Environment.Inspect]: {
        position: "fixed",
        left: "calc(100% - 220px)",
        bottom: "5px",
        zIndex: '-1'
    },
    [Enum_Environment.Common]: {
        position: "fixed",
        left: "",
        bottom: ""
    },
    [Enum_Environment.Replay]: {
        position: "fixed",
        left: "",
        bottom: ""
    },
    [Enum_Environment.SettingPanel]: {
        position: "fixed",
        left: "",
        bottom: ""
    },
    [Enum_Environment.RiskWarning]: {
        position: "fixed",
        left: "calc(100% - 576px)",
        bottom: "90px"
    },
    [Enum_Environment.Bookmark]: {
        position: "fixed",
        left: "",
        bottom: ""
    },
    [Enum_Environment.RiskWarningBigScreen]: {
        position: "fixed",
        left: "450px",
        bottom: "70px"
    },
    [Enum_Environment.ServiceScenario]: {
        position: "fixed",
        left: "450px",
        bottom: "70px"
    }
}